import React, { useState, useContext, useEffect } from "react";

import PageBody from "../GeneralComponents/PageBody";
import InputFile from "../GeneralComponents/InputFile";
import ParqueDelete from "./ParqueDelete";
import GeneralContext from "../GeneralContext/GeneralContext";
import BreadcrumbStandard from "../GeneralComponents/BreadcrumbStandard";

export default function ParqueBaja() {
  const { pageTitle, setPageTitle, setDrawerHidding } =
    useContext(GeneralContext);
      const links = [
    { name: "Estado de Parque", path: "/parque_lista" },
    { name: "Baja", path: "/parque_bajas" },
  ];
  useEffect(() => {
    setPageTitle("Listado de reportes");
  }, [pageTitle, setPageTitle]);

  useEffect(() => {
    setDrawerHidding(false);
  }, []);

  return (
    <PageBody>
    <BreadcrumbStandard links={links} />
      <ParqueDelete></ParqueDelete>
    </PageBody>
  );
}
